<template>
  <div id="history">
    <v-timeline>
      <v-timeline-item v-for="(year, i) in years" :key="i" :color="year.color" small>
        <span
          slot="opposite"
          :class="`headline font-weight-bold ${year.color}--text`"
          v-text="year.year"
        ></span>
        <div class="py-3">
          <h2 :class="`headline font-weight-light mb-3 ${year.color}--text`" v-text="year.contentTitle"></h2>
          <img :src="year.image">
          <div class="is-hidden-mobile" v-text="$t(year.content)"></div>
        </div>
      </v-timeline-item>
    </v-timeline>
  </div>
</template>

<script>
export default {
  components: {},

  data() {
    return {
      years: [
        {
          color: "cyan",
          year: "2006",
          content: 'about.history.first',
          contentTitle: "EESTEC Olympics 1",
          image: "https://i.imgur.com/Aoe2fjj.png"
        },
        {
          color: "green",
          year: "2006",
          content: 'about.history.second',
          contentTitle: "EESTEC Olympics Second Eddition Axway",
          image: "https://i.imgur.com/rcZpwho.png"
        },
        {
          color: "pink",
          year: "2011",
          content: 'about.history.third',
          contentTitle: "EESTEC Olympics 3",
          image: "https://i.imgur.com/07xN4rK.png"
        },
        {
          color: "amber",
          year: "2013",
          content: 'about.history.fourth',
          contentTitle: "EESTEC Olympics 4",
          image: "https://i.imgur.com/OFP26nj.png"
        },
        {
          color: "orange",
          year: "2014",
          content: 'about.history.fifth',
          contentTitle: "EESTEC Olympics 5",
          image: "https://i.imgur.com/6YmNOUt.png"
        }
        ,
        {
          color: "orange",
          year: "2015",
          content: 'about.history.sixth',
          contentTitle: "EESTEC Olympics 6",
          image: "https://i.imgur.com/dEDX5SU.png"
        },
        {
          color: "orange",
          year: "2016",
          content: 'about.history.seventh',
          contentTitle: "EESTEC Olympics 7",
          image: "https://i.imgur.com/uNiHEEa.png"
        },
        {
          color: "orange",
          year: "2017",
          content: 'about.history.eighth',
          contentTitle: "EESTEC Olympics 8",
          image: "https://i.imgur.com/OupzqLx.png"
        }
      ].reverse()
    };
  }
};
</script>
<!-- 2011 2x2006 fara 2012-->

<style lang="scss" scoped>

#history {
  @extend %eestec-page;
}

div { 
  text-align:justify;
}

img {
  max-height: 30vh;
  max-width: 80%;
  display: block;
  margin: auto;
}
</style>
